import { useTranslate } from "@similarweb/i18n-provider";

import { useAccountAdminsQuery } from "app/pages/sales-intelligence/query/queries/useAccountAdminsQuery";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

interface ICrmManagementReadOnlyState {
    readonly isReadOnly: boolean;
    readonly disabledTooltip: string | undefined;
}

export const useCrmManagementReadOnly = (): ICrmManagementReadOnlyState => {
    const { translate } = useTranslate();
    const accountAdmins = useAccountAdminsQuery();
    const isReadOnly = !salesSettingsHelper.hasCrmAccess();
    const adminEmail = accountAdmins.data?.join(", ") || translate("si.management.disabled-tooltip.loading");

    return {
        isReadOnly,
        disabledTooltip: isReadOnly
            ? translate("si.manage-integration.read-only.tooltip", {
                  email: adminEmail,
              })
            : undefined,
    };
};
